import styled from "styled-components";

export const NpsItems = styled.div`
   color: ${(props) => props.theme.colors.typography1.pure};

    .input{
        margin: 22px 0 0;
        background-color: transparent;
        border-radius: 8px;
        width: 100%;
        height: 11vh;
        border: 1px solid #757575;
        color: #FFFFFF;
        font-size: 0.89rem;
        padding: 8px;

        @media(min-width:618px) {
            height: 15vh;
        }
    }    
        width:100%;
        padding: 20px 20px 0;
        
        @media(max-width: 320px) {
            padding: 12px 12px 0;
        }

    .form-step {
      display: none;
    }
    .formStepActive {
      display: block;
    }
    .button{
        position: relative;
        background:  ${(props) => props.theme.colors.typography2.dark};;
        text-align: center;
    }

`
export const TextNps = styled.label`
    display: flex;
    font-size: 0.85rem;
    justify-content: center;
`
export const TextRating = styled.label`
    display: flex;
    justify-content: space-between;
    text-align: center;
    font-size: 0.75rem;
`
export const TextInput = styled.label`
    display: flex;
    font-size: 0.85rem;
`
export const RatingStyle = styled.div` 
    display:grid;
    justify-content: center;
    user-select:none;
    .rating{
        font-size: 4rem;
    }
`
export const BackButton = styled.div` 
    font-size: 0.8rem;
    color: ${(props) => props.theme.colors.typography2.light};
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0 15px;

    @media(min-width: 767px) {
        margin: 10px 0 20px;
    }
    button{
        display:flex;
        align-items:center;
        background: none;
        border: none;
        color: ${(props) => props.theme.colors.typography1.pure};
    }
    svg{ 
        cursor: pointer;
        @media(min-width: 1024px) {
            width: 16px;
        }
    }
    .svg__exit_image--button{    
        align-items:center; 
        width: 8px;
        height: 8px;
    }
`
export const Container = styled.div`
    display: flex;
    margin-top: 15px;
    flex-direction: column;
    
    .svg{
        cursor:pointer;
        width:35px;
    }
    .svg__icon{
        width:30px;
        height:50px;
        align-self: center;
    }
    .responseText{
        align-self: center;
        text-align:center;
        padding: 10px 20px;
        font-size: 1rem;
    }
`